import { Injectable } from '@angular/core';
import { RoutingService, WindowRef } from '@spartacus/core';
import { SchemaBuilder } from '@spartacus/storefront';
import { map, Observable } from 'rxjs';

/**
 * Описывает один пункт навигационного меню сайта.
 */
interface SiteNavigationItem {
  name: string;
  path: string;
  description?: string;
}

/**
 * Формирует структурированные данные типа SiteNavigationElement для главной страницы (https://schema.org/SiteNavigationElement)
 *
 * Разметка выводится только на главной странице сайта.
 */
@Injectable({
  providedIn: 'root',
})
export class SiteNavigationSchemaBuilder implements SchemaBuilder {
  private readonly navigationItems: SiteNavigationItem[] = [
    { name: 'Строительные материалы', path: '/category/stroitelnye-materialy-5521' },
    { name: 'Распродажа', path: '/p/1211', description: 'Скидки на строительные материалы' },
    {
      name: 'Прокат инструмента',
      path: '/category/prokat-instrumenta-98001',
      description: 'Можно в аренду пока не решились на покупку',
    },
    {
      name: 'Быстро привезем',
      path: '/bystraya-dostavka',
      description: 'Быстро привозим все, что закончилось, чтобы вы не сдавались',
    },
    { name: 'Забери по пути', path: '/pickup-points', description: 'На объект и по дороге домой' },
    {
      name: 'Статьи',
      path: '/articles',
      description: 'Полезные советы, инструкции и множество других идей для вашего следующего проекта',
    },
    { name: 'О компании', path: '/about' },
    { name: 'Контакты', path: '/contacts' },
  ];

  constructor(
    private routingService: RoutingService,
    private winRef: WindowRef,
  ) {}

  /**
   * Возвращает данные навигации, если мы на главной странице (на остальных страницах возвращает пустой объект)
   */
  build(): Observable<Record<string, any>> {
    return this.routingService
      .getRouterState()
      .pipe(map((state) => (state?.state?.semanticRoute === 'home' ? this.collect() : {})));
  }

  protected collect(): Record<string, any> {
    const origin = this.winRef.location?.origin ?? '';

    return {
      '@context': 'https://schema.org',
      '@type': 'SiteNavigationElement',
      name: 'Основная навигация SDVOR',
      url: origin,
      hasPart: this.navigationItems.map((item) => this.buildNavigationItem(item, origin)),
    };
  }

  private buildNavigationItem(item: SiteNavigationItem, origin: string): Record<string, any> {
    const result: Record<string, any> = {
      '@type': 'SiteNavigationElement',
      name: item.name,
      url: origin + item.path,
    };

    if (item.description) {
      result.description = item.description;
    }

    return result;
  }
}
